var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 256V16H16V256H496Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496V256H16V496H496Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.053 173.099C290.065 174.466 302.577 178.856 313.59 185.918C324.604 192.98 333.815 202.519 340.487 213.772C347.16 225.026 351.11 237.684 352.022 250.735C352.934 263.787 350.783 276.871 345.74 288.943C340.698 301.016 332.903 311.743 322.979 320.268C313.055 328.793 301.275 334.88 288.58 338.045C275.885 341.209 262.627 341.362 249.862 338.492C237.097 335.622 225.18 329.808 215.061 321.515L202.781 336.498C215.234 346.705 229.902 353.861 245.612 357.393C261.322 360.925 277.641 360.737 293.265 356.842C308.89 352.948 323.388 345.456 335.602 334.963C347.817 324.471 357.41 311.268 363.616 296.41C369.823 281.551 372.47 265.448 371.347 249.385C370.225 233.321 365.363 217.743 357.151 203.892C348.938 190.041 337.602 178.302 324.047 169.61C310.491 160.918 295.092 155.515 279.078 153.832L277.053 173.099Z",
    fill: "#F9D616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M379.671 245.617C380.39 252.914 380.39 260.263 379.671 267.56L358.249 265.45C358.83 259.556 358.83 253.62 358.249 247.727L379.671 245.617Z",
    fill: "#F9D616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231.433 205.869H305.123L245.508 249.184L268.278 179.098L291.048 249.184L231.433 205.869Z",
    fill: "#F9D616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M358.511 351.752C364.018 357.082 371.435 362.336 376.814 367.11C382.194 371.884 386.315 375.853 389.651 381.277C394.54 389.225 389.05 398.227 381.437 392.943C377.32 390.086 374.733 382.372 368.425 375.989C363.754 372.012 360.073 367.843 348.332 365.831C347.768 365.735 347.603 364.544 348.046 364.024L358.511 351.752Z",
    fill: "#F9D616"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M277.406 325.247L306.461 342.427L312.777 366.935L346.128 364.408L360.782 347.228L306.461 309.582L277.406 325.247V325.247Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M346.721 362.335C309.36 337.488 285.602 324.072 249.797 303.714C235.731 295.716 213.888 275.613 231.118 241.979C232.203 264.06 319.471 324.669 356.346 351.023L346.721 362.335Z",
    fill: "#F9D616"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255.486 281.729C284.252 308.837 320.478 330.952 352.798 355.396Z",
    fill: "#222222"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M255.486 281.729C284.252 308.837 320.478 330.952 352.798 355.396",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M362.129 361.784C362.928 361.784 363.575 361.136 363.575 360.337C363.575 359.538 362.928 358.891 362.129 358.891C361.33 358.891 360.682 359.538 360.682 360.337C360.682 361.136 361.33 361.784 362.129 361.784Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/AO.534f9f3ff1ac6a6813f9862cee4f5ba2.svg";
export { ForwardRef as ReactComponent };